import { useEffect, useRef, useState } from 'react';
import { useCall } from '../context/CallContext';
import styles from './audio-call.module.css';
// import AudioDebugTest from '../extra/AudioDebugTest';
import { CallIcon, EndCallIcon, MuteIcon, UnmuteIcon } from './icons/Icons';

const AudioCall = () => {
 const { 
        callState, 
        acceptCall, 
        rejectCall, 
        endCall,
        toggleMute,
        toggleMinimize,
        remoteStream,
    } = useCall();

    const remoteAudioRef = useRef(null);
    const [audioError, setAudioError] = useState(null);

    // Debug call state changes
    useEffect(() => {
        // console.log('🎨 CallUI - State changed:', callState);
    }, [callState]);

    // Play remote audio with enhanced debugging
    // useEffect(() => {
    //     if (remoteAudioRef.current && remoteStream) {
    //         // console.log('🔊 CallUI - Setting remote stream to audio element');
    //         // console.log('   Stream active:', remoteStream.active);
    //         // console.log('   Stream tracks:', remoteStream.getTracks().map(t => ({
    //             // kind: t.kind,
    //             // enabled: t.enabled,
    //             // muted: t.muted,
    //             // readyState: t.readyState
    //         // })));
            
    //         remoteAudioRef.current.srcObject = remoteStream;
            
    //         // CRITICAL: Set audio properties
    //         remoteAudioRef.current.muted = false;
    //         remoteAudioRef.current.volume = 1.0;
            
    //         // Force play with user interaction handling
    //         const playAudio = async () => {
    //             try {
    //                 // Unmute all tracks
    //                 remoteStream.getAudioTracks().forEach(track => {
    //                     if (!track.enabled) {
    //                         track.enabled = true;
    //                         // console.log('   ✅ Enabled audio track');
    //                     }
    //                 });
                    
    //                 await remoteAudioRef.current.play();
    //                 // console.log('   ✅ Remote audio playing');
    //                 // console.log('   Audio element muted:', remoteAudioRef.current.muted);
    //                 // console.log('   Audio element volume:', remoteAudioRef.current.volume);
    //                 setAudioError(null);
    //             } catch (err) {
    //                 console.error('   /❌ Error playing audio:', err);
    //                 setAudioError(err.message);
                    
    //                 // If autoplay blocked, user needs to interact
    //                 if (err.name === 'NotAllowedError') {
    //                     // console.log('   ⚠️  Autoplay blocked - user interaction required');
    //                 }
    //             }
    //         };
            
    //         playAudio();
            
    //         // Also try again after a delay
    //         const retryTimeout = setTimeout(() => {
    //             // console.log('🔄 Retrying audio play...');
    //             playAudio();
    //         }, 1000);
            
    //         return () => clearTimeout(retryTimeout);
    //     }
    // }, [remoteStream]);

    useEffect(() => {
        if (remoteAudioRef.current && remoteStream) {
            remoteAudioRef.current.srcObject = remoteStream;
            remoteAudioRef.current.muted = false;
            remoteAudioRef.current.volume = 1;

            // remoteStream.getAudioTracks().forEach(t => t.enabled = true);

            remoteAudioRef.current.play().catch(() => {});
        }
    }, [remoteStream]);


    useEffect(() => {
        if (callState.isInCall) {
            // console.log('📱 CallUI - Rendering call interface');
            // console.log('   Type:', callState.callType);
            // console.log('   Minimized:', callState.isMinimized);
            // console.log('   Other user:', callState.otherUser);
        }
    }, [callState.isInCall, callState.callType, callState.isMinimized]);

    if (!callState.isInCall) {
        // console.log('📱 CallUI - Not in call, hiding UI');
        return null;
    }

    const handleAccept = async () => {
        // console.log('👆 CallUI - Accept button clicked');
        // console.log('   Current state:', callState);
        
        await acceptCall();
        
        // console.log('   ✅ Accept call function completed');
        
        // Try playing audio again after accepting
        if (remoteAudioRef.current) {
            setTimeout(() => {
                // console.log('   🔊 Attempting to play audio element');
                
                // Force unmute and play
                if (remoteAudioRef.current.srcObject) {
                    remoteAudioRef.current.muted = false;
                    remoteAudioRef.current.volume = 1.0;
                    
                    remoteAudioRef.current.srcObject.getAudioTracks().forEach(track => {
                        track.enabled = true;
                    });
                }
                
                remoteAudioRef.current.play()
                    // .then(() => console.log('      ✅ Audio playing'))
                    // .catch(err => console.error('      ❌ Error playing after accept:', err));
            }, 500);
        }
    };

    const handleUnmuteClick = () => {
        if (remoteAudioRef.current?.srcObject) {
            // console.log('🔊 Manual unmute triggered');
            remoteAudioRef.current.muted = false;
            remoteAudioRef.current.volume = 1.0;
            
            remoteAudioRef.current.srcObject.getAudioTracks().forEach(track => {
                track.enabled = true;
                // console.log('   Track enabled:', track.enabled, 'Muted:', track.muted);
            });
            
            remoteAudioRef.current.play()
                .then(() => {
                    // console.log('   ✅ Audio playing after manual unmute');
                    setAudioError(null);
                })
                .catch(err => console.error('   ❌ Error:', err));
        }
    };

    const handleReject = () => {
        // console.log('👆 CallUI - Reject button clicked');
        rejectCall();
    };

    const handleEnd = () => {
        // console.log('👆 CallUI - End call button clicked');
        endCall();
    };

    const handleMinimize = () => {
        // console.log('👆 CallUI - Minimize button clicked');
        toggleMinimize();
    };

    const displayName = callState.otherUser?.name || 
                       `User ${callState.otherUser?.id?.slice(-4) || 'Unknown'}`;
    
    const profilePicture = callState.otherUser?.profilePicture;

    return (
        <>
         {/* <AudioDebugTest remoteStream={remoteStream} /> */}
        <div className={`${styles.callOverlay} ${callState.isMinimized ? styles.minimized : ''}`}>
            <div className={styles.callContainer}>
                <div className={styles.callHeader}>
                    <h3>
                        {callState.callType === 'incoming' && 'Incoming Call'}
                        {callState.callType === 'outgoing' && 'Calling...'}
                        {callState.callType === 'active' && 'In Call'}
                    </h3>
                    <button 
                        className={styles.minimizeBtn}
                        onClick={handleMinimize}
                        title={callState.isMinimized ? "Maximize" : "Minimize"}
                    >
                        {callState.isMinimized ? '□' : '_'}
                    </button>
                </div>

                {!callState.isMinimized && (
                    <div className={styles.callBody}>
                        <div className={styles.callerInfo}>
                            <div className={styles.avatar}>
                                {profilePicture ? (
                                    <img 
                                        src={profilePicture} 
                                        alt={displayName}
                                        title={displayName}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                ) : null}
                                <i className="fas fa-user" style={{ display: profilePicture ? 'none' : 'flex' }}></i>
                            </div>
                            <p className={styles.callerName}>{displayName}</p>
                            
                            {callState.callType === 'active' && (
                                <p className={styles.callStatus}>
                                    <span className={styles.statusIndicator}></span>
                                    Connected
                                </p>
                            )}
                            
                            {audioError && (
                                <p className={styles.audioWarning} onClick={handleUnmuteClick} style={{ cursor: 'pointer' }}>
                                    🔊 Click here to enable audio
                                </p>
                            )}
                        </div>

                        <div className={styles.callControls}>
                            {callState.callType === 'incoming' && (
                                <>
                                    <button 
                                        className={`${styles.callBtn} ${styles.acceptBtn}`}
                                        onClick={handleAccept}
                                    >
                                        <i className="fas fa-phone-slash"></i>
                                        Accept<CallIcon/>
                                    </button>
                                    <button 
                                        className={`${styles.callBtn} ${styles.rejectBtn}`}
                                        onClick={handleReject}
                                    >
                                        <i className="fas fa-phone-slash"></i>
                                        
                                        Reject<EndCallIcon/>
                                    </button>
                                </>
                            )}

                            {(callState.callType === 'outgoing' || callState.callType === 'active') && (
                                <>
                                    {callState.callType === 'active' && (
                                        <button 
                                            className={styles.unmuteBtn}
                                            onClick={toggleMute}
                                            title={callState.isMuted ? 'Mute' : 'Unmute'}
                                        >
                                            {callState.isMuted ? <MuteIcon/> : <UnmuteIcon/>}
                                        </button>
                                    )}
                                    <button 
                                        className={`${styles.callBtn} ${styles.endBtn}`}
                                        onClick={handleEnd}
                                    >
                                        <i className="fas fa-phone-slash"></i>
                                        
                                        End Call<EndCallIcon/>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                )}

                {callState.isMinimized && (
                    <div className={styles.minimizedContent}>
                        <div className={styles.miniAvatar}>
                            {profilePicture ? (
                                <img src={profilePicture} alt={displayName} title={displayName} />
                            ) : (
                                <i className="fas fa-user"></i>
                            )}
                        </div>
                        <i className="fas fa-phone-volume"></i>
                        <span>{displayName}</span>
                        <button 
                            className={`${styles.endBtnMini}`}
                            onClick={handleEnd}
                            title="End Call"
                        >
                            <EndCallIcon/>
                        </button>
                    </div>
                )}
            </div>

            {/* Hidden audio element for remote stream */}
            <audio 
                ref={remoteAudioRef} 
                autoPlay 
                playsInline
                controls={false}
            />
        </div>
        </>
    );
};
 


export default AudioCall;